__turbopack_context__.v({
  "homepageSurface": "homepageGlobal-module-scss-module__4uyRBq__homepageSurface",
});
